import { Box } from '../../Box';
import { Button } from '../../Button';
import { idBuilder } from '../../internal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const splitStyle = {
  display: 'flex',
  gap: '16px',
  justifyContent: 'space-between',
  flex: 1
};
const stackedStyle = {
  display: 'flex',
  gap: '8px',
  flexDirection: 'column',
  flex: 1
};
const rightAlignedStyle = {
  display: 'flex',
  gap: '16px',
  justifyContent: 'flex-end',
  flex: 1
};
const fluidStyle = {
  display: 'flex',
  gap: '16px',
  justifyContent: 'space-evenly',
  flexGrow: 1
};
const resolveStyle = layout => {
  switch (layout) {
    case 'stacked':
      {
        return stackedStyle;
      }
    case 'fluid':
      {
        return fluidStyle;
      }
    case 'split':
      {
        return splitStyle;
      }
    default:
      {
        return rightAlignedStyle;
      }
  }
};
export const OptionButtons = props => {
  const {
    id,
    size,
    layout,
    optionButtons,
    customIdentifiers = {},
    ...rest
  } = props;
  return /*#__PURE__*/_jsxs(Box, {
    sx: resolveStyle(layout),
    className: 'ids-action-button-options',
    id: customIdentifiers['optionsRoot']?.id || idBuilder('ids-action-button-options', id),
    "data-testid": customIdentifiers['optionsRoot']?.dataTestId || idBuilder('ids-action-button-options', rest['data-testid']),
    children: [optionButtons[0] && /*#__PURE__*/_jsx(Button, {
      buttonStyle: optionButtons[0].buttonStyle || 'secondary',
      onClick: optionButtons[0].action,
      size: size,
      className: 'ids-action-button-option',
      id: optionButtons[0].customIdentifiers && optionButtons[0].customIdentifiers['optionButton0']?.id || idBuilder('ids-action-button-option0', id),
      disabled: optionButtons[0].disabled,
      isLoading: optionButtons[0].isLoading,
      "data-testid": optionButtons[0].customIdentifiers && optionButtons[0].customIdentifiers['optionButton0']?.dataTestId || idBuilder('ids-action-button-option0', rest['data-testid']),
      children: optionButtons[0].label
    }), optionButtons[1] && /*#__PURE__*/_jsx(Button, {
      buttonStyle: optionButtons[1].buttonStyle || 'secondary',
      onClick: optionButtons[1].action,
      size: size,
      className: 'ids-action-button-option',
      id: optionButtons[1].customIdentifiers && optionButtons[1].customIdentifiers['optionButton1']?.id || idBuilder('ids-action-button-option1', id),
      disabled: optionButtons[1].disabled,
      isLoading: optionButtons[1].isLoading,
      "data-testid": optionButtons[1].customIdentifiers && optionButtons[1].customIdentifiers['optionButton1']?.dataTestId || idBuilder('ids-action-button-option1', rest['data-testid']),
      children: optionButtons[1].label
    })]
  });
};